import './App.css';
import { useEffect, useState } from "react";
import {Routes, Route, Outlet } from 'react-router-dom';
import { auth } from "./firebase.js";
import { onAuthStateChanged } from "firebase/auth";


import Login from './Pages/Login/login.jsx';
import Rewards from './Pages/Rewards/rewards.jsx';
import Admin from './Pages/Admin/admin.jsx'
import UserList from './Pages/Admin/UserList/userList.jsx'
import CreateUser from './Pages/Admin/CreateUser/createUser.jsx'
import Customers from './Pages/Admin/Customers/customers.jsx'
import ActiveAlterations from './Pages/Admin/ActiveAlterations/activeAlterations.jsx'
import Reports from './Pages/Admin/Reports/reports.jsx'
import Settings from './Pages/Admin/Settings/settings.jsx'
import RewardsLedger from './Pages/Admin/Rewards/rewardsLedger.jsx'
import RewardsActivity from './Pages/Admin/Rewards/rewardsActivity.jsx'
import RewardsPointEvents from './Pages/Admin/Rewards/rewardsPointEvents.jsx'
import Marketing from './Pages/Admin/Marketing/marketing.jsx'
import EmailMarketing from './Pages/Admin/EmailMarketing/emailMarketing.jsx'
import PushNotifications from './Pages/Admin/PushNotifications/pushNotifications.jsx'
import Users from './Pages/Users/users.jsx'
import UserDashboard from './Pages/Users/UserDashboard/userDashboard.jsx'
import MyOrders from './Pages/Users/MyOrders/myOrders.jsx'

import Header from './Components/Header/header.jsx'
import SideBar from './Components/SideBar/sideBar.jsx';

function Layout() {
  const getIsMobileView = () =>
    typeof window !== "undefined" ? window.innerWidth <= 1400 : false;

  const getInitialSidebarState = () =>
    typeof window !== "undefined" ? window.innerWidth > 1400 : true;

  const [isMobileView, setIsMobileView] = useState(getIsMobileView);
  const [isSidebarOpen, setIsSidebarOpen] = useState(getInitialSidebarState);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 1400;
      setIsMobileView(isMobile);

      if (!isMobile) {
        setIsSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobileView) {
      setIsSidebarOpen(false);
    }
  }, [isMobileView]);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div id='page_container' className={isMobileView ? "mobile-layout" : ""}>
      <Header
        isMobileView={isMobileView}
        isSidebarOpen={isSidebarOpen}
        onToggleSidebar={toggleSidebar}
      />
      <SideBar
        isMobileView={isMobileView}
        isSidebarOpen={isSidebarOpen}
        onCloseSidebar={closeSidebar}
      />
      {isMobileView && (
        <div
          className={`sidebar-backdrop ${isSidebarOpen ? "visible" : ""}`}
          onClick={closeSidebar}
        />
      )}
      <main>
        <Outlet />
      </main>
    </div>
  )
}


function App() {
  const [claims, setClaims] = useState({});

  useEffect(() => {
    // Listen for auth state changes - this will persist across browser sessions
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Force refresh token to get latest claims
        try {
          await user.getIdToken(true);
          const tokenResult = await user.getIdTokenResult();
          setClaims(tokenResult.claims || {});
        } catch (error) {
          console.error("Error refreshing token:", error);
          setClaims({});
        }
      } else {
        setClaims({});
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/rewards" element={<Rewards />} />

        <Route element={<Layout />}>
          {claims.admin && (
            <Route
              path="/admin"
              element={
                <Admin />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/users"
              element={
                <UserList />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/create-user"
              element={
                <CreateUser />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/customers"
              element={
                <Customers />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/active-alterations"
              element={
                <ActiveAlterations />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/marketing"
              element={
                <Marketing />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/email-marketing"
              element={
                <EmailMarketing />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/push-notifications"
              element={
                <PushNotifications />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/reports"
              element={
                <Reports />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/settings"
              element={
                <Settings />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/rewards"
              element={
                <RewardsActivity />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/rewards/events"
              element={
                <RewardsPointEvents />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/rewards/ledger"
              element={
                <RewardsLedger />
              }
            />
          )}
          {claims.admin && (
            <Route
              path="/admin/users-list"
              element={
                <Users />
              }
            />
          )}
          {claims.user && (
          <Route
            path="/user"
            element={
                <UserDashboard />
              }
            />
          )}
          {claims.user && (
            <Route
              path="/user/my-orders"
              element={
                <MyOrders />
            }
          />
          )}
        </Route>
        <Route path="*" element={<Login />} />
      </Routes>
    </div>
  );
}

export default App;
